import { Subscribe } from '@react-rxjs/core'
import React from 'react'

import { useResultWithLeftEffect } from '../../../../../../../hooks/useResultWithLeftEffect'
import {
  latestSuggestedFeaturedProducts$,
  Product,
  useSuggestedFeaturedProducts,
} from '../../../../../../../lib/sanity-dispensaries/manage/featured-products'
import { constUndefined } from '../../../../../../../utils/constant'
import Spinner from '../../../../../../Spinner'
import { ProductListEntry } from '../ProductListEntry'
import * as Styled from './styled'

export interface ProductListSuggestionsProps {
  className?: string
  addedProducts?: Product[]
  onAdd: (product: Product) => void
  onRemove: (product: Product) => void
}

const pluckData = <T,>({ data }: { data: T }) => data

const ProductListSuggestionsContent: React.FC<ProductListSuggestionsProps> = ({
  addedProducts,
  onAdd,
  onRemove,
}) => {
  const [suggestedProductsLeft, suggestedProducts] = useResultWithLeftEffect(
    useSuggestedFeaturedProducts(),
    pluckData,
    constUndefined,
  )

  if (suggestedProductsLeft || !suggestedProducts || suggestedProducts.length === 0) {
    return (
      <Styled.ItemsContainer>
        <div>No suggested products.</div>
      </Styled.ItemsContainer>
    )
  }

  return (
    <Styled.ItemsContainer>
      {suggestedProducts.map((suggestedProduct) => (
        <ProductListEntry
          key={suggestedProduct.sku}
          product={suggestedProduct}
          actions={
            addedProducts
              ? {
                  _tag: 'suggested',
                  added: !!addedProducts.find(
                    (addedProduct) => addedProduct.sku === suggestedProduct.sku,
                  ),
                  onAdd,
                  onRemove,
                }
              : undefined
          }
        />
      ))}
    </Styled.ItemsContainer>
  )
}

export const ProductListSuggestions: React.FC<ProductListSuggestionsProps> = (props) => {
  return (
    <Subscribe source$={latestSuggestedFeaturedProducts$} fallback={<Spinner loading />}>
      <ProductListSuggestionsContent {...props} />
    </Subscribe>
  )
}
